import { Card } from "@/components/ui/card";
import type { MarketAnalysis } from "@/integrations/supabase/types/tables/realEstate";

interface PropertyMarketAnalysisProps {
  marketAnalysis: MarketAnalysis | null;
}

export const PropertyMarketAnalysis = ({ marketAnalysis }: PropertyMarketAnalysisProps) => {
  if (!marketAnalysis) return null;

  return (
    <Card className="p-6">
      <h2 className="text-xl font-semibold mb-4">Market Analysis</h2>
      <div className="space-y-4">
        {marketAnalysis.market_value && (
          <div>
            <h3 className="font-medium mb-2">Market Value</h3>
            <p className="text-muted-foreground">
              GHS {marketAnalysis.market_value.toLocaleString()}
            </p>
          </div>
        )}
        {marketAnalysis.appreciation_rate && (
          <div>
            <h3 className="font-medium mb-2">Annual Appreciation Rate</h3>
            <p className="text-muted-foreground">
              {marketAnalysis.appreciation_rate}%
            </p>
          </div>
        )}
        {marketAnalysis.price_trends?.length > 0 && (
          <div>
            <h3 className="font-medium mb-2">Price Trends</h3>
            <ul className="list-disc list-inside space-y-2">
              {marketAnalysis.price_trends.map((trend, index) => (
                <li key={index} className="text-muted-foreground">
                  {trend}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </Card>
  );
};